export interface ProductPurchaseOrderHistory {
  id: string;
  orderNo: string;
  orderDate: Date;
  supplierKey: string;
  supplierName: string;
  orderQuantity: number;
  orderPrice: number;
  orderValue: number;
  orderSterlingValue: number;
  quantityReceived: number;
  orderStatus: string;
  stockNo: string;
  invoiceNo: number;
  invoiceDate: Date;
  invoicePrice: number;
  currencyCode: string;
  currencySymbol: string;
  deliveryAddress: string;
}
